import { APP_MARKET_FEATURE_FLAG, ANGULAR_APP_MARKET_ROUTE } from './constants/appMarketConstants';

const AppMarketPage = () => import(/* webpackChunkName: "AppMarketPage" */ './views/AppMarketPage.vue');

const pageProps = (route) => ({
  featureFlag: APP_MARKET_FEATURE_FLAG,
  angularRoute: ANGULAR_APP_MARKET_ROUTE,
  appCodeName: route.params.appCodeName || '',
});

const routes = [
  {
    path: '/app-market',
    name: 'appMarket',
    component: AppMarketPage,
    props: pageProps,
    meta: { i18n: 'app-market-pov', pageNameEn: 'App Market' },
  },
  {
    path: '/app-market/:appCodeName',
    name: 'appMarketAppInfo',
    component: AppMarketPage,
    props: pageProps,
    meta: { i18n: 'app-market-pov', pageNameEn: 'App Info Page' },
  },
];

export default routes;
